import { CRS } from 'leaflet'
import { lo_regions, obj2regions, width } from './Utils'

const _ENV = {
	DEV: {
		imgUrl: '/info-map/img/info-map/',
		DEBUG: true,
		extraScroll: false,
		defaultDialogTop: 100,
		refresh: 1/2, //minutes
		init: () => {
			//localStorage.setItem('app', JSON.stringify({User: {id: 241, map_options: 'powerOffThresh,unrestricted'}}))
		},
	},
	PROD: {
		imgUrl: '/info-map/img/',
		extraScroll: true,
		defaultDialogTop: 100,
		refresh: 2, //minutes
		init: () => {},
	},
}

const decoration = {
	showDialogLinks: false,
	objects: {
		showLines: true,
	},
}

const out_regions_shape = [ [[90, -1800], [90, 1800], [-90, 1800], [-90, -1800]], ...obj2regions(lo_regions) ]
	
const OPZ1 = 4
const OPMASK1 = 0.85
const OPMASK2 = 0
const OP = (zoom, OPZ2) => OPMASK1 - (OPMASK1 - OPMASK2) / (OPZ2 - OPZ1) * (Math.min(Math.max(zoom, OPZ1), OPZ2) - OPZ1)

const _MAP_TYPES = {
	MERC: {
		CRS: CRS.EPSG3857,
		CENTER: {lat: 64.8, lng: 105.3},
		MIN_ZOOM: 4,
		MAX_ZOOM: 17,
		ZOOM: 4,
		TILES_URL: '/tiles/{z}/{y}/{x}',
		//TILES_URL: 'https://инфо.сацминэнерго.рф/tiles/{z}/{y}/{x}',
		//TILES_URL: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
		//TILES_URL: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
		//TILES_URL: 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager_nolabels/{z}/{x}/{y}{r}.png',
		MAP_WIDTH: 2100, //2060,
		MAP_HEIGHT: 950, //972,
		outRegionOptions: zoom => {return {
			color: '#AAA',
			weight: width(zoom),
			opacity: OP(zoom, 6),
			fillColor: '#FFF',
			fillOpacity: OP(zoom, 7)
		}},
	}
}

export {
	_ENV,
	_MAP_TYPES,
	out_regions_shape,
	decoration,
}


